import _styled from "styled-components";
var _excluded = ["className", "style", "children", "variant", "size", "disabled", "value", "onChange"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType, useControlled, variantSwitch, getValidChildren } from '@adsk/alloy-helpers';
import theme from '@adsk/alloy-theme';
import Button from '../Button';
var UNSET = 'unset';
var VARIANTS = {
  SECONDARY: Button.VARIANTS.SECONDARY,
  TERTIARY: Button.VARIANTS.TERTIARY
};
var SIZES = {
  SMALL: Button.SIZES.SMALL,
  MEDIUM: Button.SIZES.MEDIUM
};
/**
 * ButtonGroup used for group of buttons
 * we want to group together and manage their selected state
 */

var ButtonGroup = function ButtonGroup(_ref) {
  var _variants;

  var className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? VARIANTS.SECONDARY : _ref$variant,
      size = _ref.size,
      disabled = _ref.disabled,
      value = _ref.value,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useControlled = useControlled(UNSET, value, onChange),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      selected = _useControlled2[0],
      setSelected = _useControlled2[1]; // if has only one button return button instead of ButtonGroup


  if (React.Children.count(children) === 1) {
    return children;
  }

  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    className: className,
    "aria-selected": !!selected && selected !== UNSET
  }, props, {
    $_css: [{
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '2px'
    }, variantSwitch({
      statement: variant,
      variants: (_variants = {}, _defineProperty(_variants, VARIANTS.SECONDARY, {
        transition: theme.transitions.create(['box-shadow', 'border']),
        '&:hover': {
          boxShadow: theme.halos.hover
        },
        '& > button:first-child': {
          borderRadius: '2px 0 0 2px'
        },
        '& > button:not(:first-child):not(:last-child)': {
          borderRadius: 0,
          borderLeft: 'none'
        },
        '& > button:last-child': {
          borderRadius: '0 2px 2px 0',
          borderLeft: 'none'
        }
      }), _defineProperty(_variants, VARIANTS.TERTIARY, _objectSpread({
        '& > button:first-child': {
          borderRadius: '2px 0 0 2px',
          borderRight: "1px solid ".concat(theme.colors.charcoal200)
        },
        '& > button:not(:first-child):not(:last-child)': {
          borderRadius: 0,
          borderRight: "1px solid ".concat(theme.colors.charcoal200)
        },
        '& > button:last-child': {
          borderRadius: '0 2px 2px 0'
        },
        '&:hover': {
          button: {
            borderRightColor: theme.colors.white
          },
          '& > button:not(:first-child):not(:last-child)': {
            borderRightColor: theme.colors.white
          }
        }
      }, selected !== UNSET && {
        button: {
          borderRightColor: theme.colors.white
        }
      })), _variants)
    }), style]
  }), React.Children.map(getValidChildren(children), function (_child, position) {
    var _variants2;

    var child = _child;
    var selectionValue = child.props.value || position;
    return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
      selected: selected === selectionValue,
      onClick: function onClick(e) {
        if (child.props.onClick) {
          child.props.onClick(e);
        }

        setSelected(selectionValue);
      },
      variant: variant,
      size: size,
      disabled: disabled || child.props.disabled,
      style: [{
        '&:hover': _objectSpread({
          boxShadow: 'none'
        }, selected !== selectionValue && {
          background: theme.colors.charcoal050
        }),
        '&:focus': {
          boxShadow: theme.halos.focus
        },
        '&:active': {
          boxShadow: theme.halos.active
        },
        '&[disabled]': {
          '&:hover': {
            background: theme.colors.white
          }
        }
      }, variantSwitch({
        statement: variant,
        variants: (_variants2 = {}, _defineProperty(_variants2, VARIANTS.SECONDARY, {
          '&[disabled]': {
            borderColor: theme.colors.charcoal400,
            color: theme.colors.charcoal500,
            svg: {
              color: theme.colors.charcoal400
            }
          }
        }), _defineProperty(_variants2, VARIANTS.TERTIARY, {
          '&[disabled]': {
            color: theme.colors.charcoal500,
            svg: {
              color: theme.colors.charcoal400
            }
          }
        }), _variants2)
      }), child.props.style]
    }));
  }));
};

ButtonGroup.VARIANTS = VARIANTS;
ButtonGroup.SIZES = SIZES;
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.defaultProps = {
  size: SIZES.MEDIUM,
  variant: VARIANTS.SECONDARY
};
ButtonGroup.propTypes = {
  /**  The component's children tabs */
  children: PropTypes.node,

  /** Styles applied to the root element */
  style: stylePropType,

  /** Class applied to the root element */
  className: PropTypes.string,

  /**  The style variant of buttons, defaults to 'secondary' */
  variant: PropTypes.oneOf(Object.values(VARIANTS)),

  /**  The size of buttons, defaults to 'medium' */
  size: PropTypes.oneOf(Object.values(SIZES)),

  /** Disable buttons functionality */
  disabled: PropTypes.bool,

  /** value for controlled usage */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** onChange handler for controlled usage */
  onChange: PropTypes.func
};
export default ButtonGroup;

var _StyledDiv = _styled("div").withConfig({
  displayName: "ButtonGroup___StyledDiv",
  componentId: "sc-10p5bal-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=ButtonGroup.js.map